module.exports = __webpack_public_path__ + "img/img8.0e0aa031.svg";